import { ShopifyObj } from "@/global";

class ShopifyAnalyticsManager {
    constructor(
        private readonly shopifyObj: ShopifyObj,
        private readonly appId: string
    ) {}

    sendVisitorInfo(params: { email?: string; phone?: string }) {
        return this.shopifyObj.analytics.visitor(params, { appId: this.appId });
    }
}

export default ShopifyAnalyticsManager;
